import { useStore } from "../stores/use-store";

export const useHasFeatureFlag = (featureFlag: string): boolean => {
  const {
    uiStore: { authStore },
  } = useStore();

  return Boolean(authStore?.user?.feature_flags?.[featureFlag]);
};
